import { render, staticRenderFns } from "./MainChartTips.vue?vue&type=template&id=3d40c24c&scoped=true&"
import script from "./MainChartTips.vue?vue&type=script&lang=js&"
export * from "./MainChartTips.vue?vue&type=script&lang=js&"
import style0 from "./MainChartTips.vue?vue&type=style&index=0&id=3d40c24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d40c24c",
  null
  
)

export default component.exports